module.exports = __webpack_public_path__ + "img/773ad08.svg";